import { useTranslation } from 'react-i18next';
import classes from './LogoContentHeader.module.css';
import logo from '../../../public/SmallLogoVertical1.png';

type LogoContentHeaderProps = {
  title: string;
  subtitle: string;
};
export const LogoContentHeader = ({
  title,
  subtitle,
}: LogoContentHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className={classes.content}>
      <img src={logo} width={148} alt={t('common.trustpulseLogoAlt')} />
      <h1 className={classes.heading}>{title}</h1>
      <p className={classes.subHeading}>{subtitle}</p>
    </div>
  );
};
